import React, { Component } from 'react'
import { GET_LIST, Loading } from 'react-admin'
import dataProvider from '../../utils/dataProvider'

import Grid from '@material-ui/core/Grid'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import TitleIcon from '@material-ui/icons/DeviceHub'
import ElemArrowIcon from '@material-ui/icons/ArrowForward'

import { Link } from 'react-router-dom'


const styles = {
    container : {
        marginTop : 40,
        marginBottom : 40,
    },
    title : {
        padding: '0 0 20px 20px',
        borderBottom: '1px solid #B5B5B7',
        display: 'flex',
        alignItems: 'center',
        color : '#64676C',
        fontSize : 18,
        fontWeight: 600,
        '& svg' : {
            color : '#33C2D5',
            paddingRight : 10,
            fontSize: 18,
        }
    },
    expandIcon : {
        color: 'rgba(0, 0, 0, 0.87)',
    },
    expPanelDetail : {
        padding: 0,
        paddingLeft : 24,
        display: 'block',
    },
    panelSummary : {
        display : 'flex',
        minHeight : '10px !important',
        borderBottom: '1px solid #33C2D5',
        '& div:first-child' : {
            margin: '12px 0 6px 0',
        },
        '& a' : { 
            textDecoration : 'none' 
        }
    },
    panelsList : {
        maxHeight : 400,
        overflowY : 'auto'
    },
    expansionPanel : {
        marginBottom: 0,
        marginTop: 2,
        borderTop: '1px solid #fff',
        backgroundColor: 'transparent',
        boxShadow : 'none',
        '&:before' : {
            backgroundColor: 'transparent',
        }
    },
    ElemSection : {
        color: '#059EAC',
        fontSize : 16,
        fontWeight : 600,
        display: 'flex',
        '& svg' : {color : '#87898F'}
    },
    ElemSectionChild: {
        color: '#059EAC',
        fontSize : 16,
        display: 'flex',
        '& svg' : {color : '#87898F'}
    },
    noMoreItems : {
        color : '#87898F',
        fontSize: 15,
        paddingLeft: 10,
    }
}

class DependantsInstalationsTree extends Component {

    constructor(props) {
        super(props)
        this.state = {
            instalationsTree: [],
            loaded : false,
            expanded: null,
            subInstalations : {}
        }
    }

    handleChange = (resource, element_id, level) => (event, expanded) => {
        this.getElementDependants(resource, element_id, level)
    }

    componentDidMount() {
        const { resource, id} = this.props
        const params = {
            pagination: { page : 1, perPage : 1},
            sort: {}
        }
        dataProvider(GET_LIST, `${resource}/${id}/dependants`, params)
            .then(result => {
                if (result.total > 0){
                    return {
                        instalationsTree : result.data,
                        loaded : true
                    }
                } else {
                    return {
                        instalationsTree : [],
                        loaded : true
                    }
                }
            })
            .then(params => this.setState({ ...params }))
            .catch((e) => 
                this.setState({ loaded : true, instalationsTree : [] })
            )
    }

    getElementDependants(resource, id, level){
        const params = {
            pagination: { page : 1, perPage : 1 },
            sort: {},
            filter: {
              level,
              resource: this.props.resource
            }
        }
        dataProvider(GET_LIST, `${resource}/${id}/dependants`, params)
            .then(result => {
                if (result.total > 0){
                    return result.data
                } else {
                    return []
                }
            })
            .then(data => {
                let subInstalations = this.state.subInstalations
                subInstalations[`${id}-${level}`] = data
                this.setState(subInstalations)
            })
            .catch((e) => {
                console.error(e)
                let subInstalations = this.state.subInstalations
                subInstalations[`${id}-${level}`] = []
                this.setState(subInstalations)
            });
    }

    renderElement(elem, level) {
        const { classes } = this.props
        level += 1
        return (
            <ExpansionPanel key={`${elem.reference}-${level}`} className={classes.expansionPanel} >
                <ExpansionPanelSummary 
                    className={classes.panelSummary} 
                    expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}>
                    <Typography className={classes.ElemSection} >
                        <ElemArrowIcon/> {`${elem.name} (${elem.total})`}
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expPanelDetail} >                    
                    {elem.result.length > 0 && elem.result.map(child => {
                        return this.renderElementChildren(child, elem.reference, level)
                    })}
                    {elem.result.length === 0 && <span className={classes.noMoreItems}>No posee instalaciones</span>}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

    renderElementChildren(elem, reference, level) {
        const { classes } = this.props
        const { subInstalations } = this.state
        level += 1
        return (
            <ExpansionPanel 
                key={`${elem.id}-${level}`}
                className={classes.expansionPanel} 
                onChange={this.handleChange(reference, elem.id, level)}
            >
                <ExpansionPanelSummary 
                    className={classes.panelSummary} 
                    expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}>
                    <Typography 
                        className={classes.ElemSectionChild} 
                        component={Link} 
                        to={{pathname: `/${reference}/${elem.id}/show`}} 
                    >
                        {`${elem.name}`}
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expPanelDetail} >                    
                    {subInstalations.hasOwnProperty(`${elem.id}-${level}`) && subInstalations[`${elem.id}-${level}`].length > 0 &&
                    subInstalations[`${elem.id}-${level}`].map(childElem => this.renderElement(childElem, level))}
                    {subInstalations.hasOwnProperty(`${elem.id}-${level}`) && subInstalations[`${elem.id}-${level}`].length === 0 && 
                    <span className={classes.noMoreItems}>No posee instalaciones</span>}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

    render(){
        const { classes } = this.props
        const { instalationsTree, loaded, subInstalations } = this.state
        let level = 0

        if(!loaded)
            return <Loading />

        return (
            <div className={classes.container}>
                <Typography className={classes.title} >
                    <TitleIcon /> {"Instalaciones"}
                </Typography>
                <Grid container spacing={24}>
                    {instalationsTree.length === 0 && <Grid item xs={12} lg={6}>No posee Instalaciones</Grid> }
                    {instalationsTree.map(elem => (
                        <Grid key={elem.reference} item xs={12} lg={6}>
                            {this.renderElement(elem, level)}
                        </Grid>
                    ))}
                </Grid>
            </div>
        )
    }

 }

 export default withStyles(styles)(DependantsInstalationsTree)
